import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getOrder } from 'selectors/entities/order/order';

import {
  type SessionConfirmationResponse,
  sessions,
} from 'services/sessions/sessions';

const useConfirmCheckoutSession = (
  options?: Omit<
    UseMutationOptions<SessionConfirmationResponse, Error, string>,
    'mutationFn'
  >,
) => {
  const order = useSelector(getOrder);

  return useMutation({
    mutationFn: (sessionId: string) =>
      sessions.confirm({
        sessionId,
        orderToken: order?.token,
        orderId: order?.id,
      }),
    ...options,
  });
};

export { useConfirmCheckoutSession };
